import type { CustomIconProps } from '../types';

const Triangle = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '13'}
        viewBox="0 0 16 13"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.07858 0.925488C6.92474 -0.290317 8.7161 -0.312044 9.5915 0.882882L15.5789 9.05563C16.6235 10.4815 15.6052 12.4898 13.8376 12.4898H2.16226C0.418634 12.4898 -0.605445 10.5294 0.390586 9.09823L6.07858 0.925488ZM8.43067 1.73331C8.13887 1.335 7.54175 1.34224 7.25969 1.74751L1.5717 9.92026C1.23969 10.3973 1.58105 11.0508 2.16226 11.0508H13.8376C14.4268 11.0508 14.7662 10.3813 14.418 9.90606L8.43067 1.73331Z"
            fill="#414042"
        />
    </svg>
);

export default Triangle;
